export default __webpack_public_path__ + "static/media/needles.c2e86878.jpg";